import {
    Backdrop,
    CircularProgress,
    Paper,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
} from "@mui/material";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../AppContext";
import SmallTablePlaceholder from "../SmallTablePlaceholder";
import OrderItemTableEntry from "./OrderItemTableEntry";
import { useStyles } from "./styles";
import { useTranslation } from "react-i18next";

const OrdersListWidget = ({
    entryItems,
    handleNext,
    backCallback,
    table,
    isInvoiceLoading,
    loading,
    distTable,
    moveLoading,
}) => {
    const classes = useStyles();
    const { t } = useTranslation();

    const tables = [
        {
            name: table?.tableDescription,
            floor: "1",
            actions: [],
        },
    ];

    const [itemsPayloads, setItemsPayloads] = useState(new Map());

    const { getMenuItem } = useContext(AppContext);

    const entryItemsKey = (entryItems || [])
        .map((item) => `${item.identifier}:${item.qty}`)
        .join("|");

    useEffect(() => {
        // A changed order or quantity must never inherit partial-payment
        // selections from the previous entry set.
        setItemsPayloads(new Map());
    }, [entryItemsKey]);

    const payableEntryItems = (entryItems || []).filter(
        (item) => !item.parent_item || item.parent_item === "NULL"
    );
    const hasSelectedEveryItemInFull = payableEntryItems.every((item) => {
        const selectedItem = itemsPayloads.get(item.identifier);
        return Number(selectedItem?.qty) === Number(item.qty);
    });
    // Paying without selecting rows, or selecting every row at its full
    // quantity, both represent a full-order payment and must skip divide.
    const payingAll =
        itemsPayloads.size === 0 || hasSelectedEveryItemInFull;

    const nextClicked = () => {
        if (loading) return;
        const totalModifiedPayload = {
            items: {},
        };

        itemsPayloads.forEach((itemPayload, identifier) => {
            totalModifiedPayload.items[identifier] = itemPayload;
        });

        totalModifiedPayload.client = "obj_3a5d-bf-457-825-0c237";
        totalModifiedPayload.payingAll = payingAll;

        if (handleNext) handleNext(totalModifiedPayload);
    };

    const handleBackCallback = () => {
        if (backCallback) {
            backCallback();
        }
    };

    const handlePayloadGenerated = (identifier, itemPayload) => {
        setItemsPayloads((previousPayloads) => {
            const nextPayloads = new Map(previousPayloads);
            if (Number(itemPayload?.qty) > 0) {
                nextPayloads.set(identifier, itemPayload);
            } else {
                nextPayloads.delete(identifier);
            }
            return nextPayloads;
        });
    };

    return (
        <div className={classes.AddPaymentWidget}>
            {!distTable && (
                <div className={classes.SmallTablePlaceholderWrapper}>
                    <SmallTablePlaceholder
                        tables={tables}
                        backCallback={handleBackCallback}
                    />
                </div>
            )}
            {isInvoiceLoading ? (
                <Backdrop open={true} className={classes.OrderItemsBackdrop}>
                    {" "}
                    <CircularProgress />{" "}
                </Backdrop>
            ) : (
                <>
                    <TableContainer
                        component={Paper}
                        className={classes.tableContainer_11}
                    >
                        <Table className={classes.table}>
                            <TableHead>
                                <TableRow>
                                    <TableCell>{t("payment.current")}</TableCell>
                                    <TableCell>{t("payment.picture")}</TableCell>
                                    <TableCell>{t("payment.item")}</TableCell>
                                    <TableCell>{t("payment.qty")}</TableCell>
                                    <TableCell>{t("payment.total")}</TableCell>
                                    <TableCell>{t("payment.qty")}</TableCell>
                                    <TableCell>{t("payment.total")}</TableCell>
                                    <TableCell>{t("payment.move")}</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {entryItems && entryItems.length > 0 ? (
                                    entryItems
                                        .filter(
                                            (i) =>
                                                !i.parent_item ||
                                                i.parent_item === "NULL"
                                        )
                                        .map((item) => {
                                            return (
                                                <OrderItemTableEntry
                                                    key={item.name}
                                                    item={item}
                                                    handlePayloadGenerated={
                                                        handlePayloadGenerated
                                                    }
                                                    image={
                                                        getMenuItem(
                                                            item.item_code
                                                        )?.cover
                                                    }
                                                    payingAll={payingAll}
                                                ></OrderItemTableEntry>
                                            );
                                        })
                                ) : (
                                    <TableRow>
                                        <TableCell colSpan={8} align="center">
                                            {t("payment.noItemsAvailable")}
                                        </TableCell>
                                    </TableRow>
                                )}
                            </TableBody>
                        </Table>
                    </TableContainer>
                    <div
                        className={classes.Actions}
                        style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                    >
                        {loading && (
                            <CircularProgress
                                style={{
                                    marginRight: "1rem",
                                    paddingTop: "3px",
                                }}
                                aria-atomic
                            />
                        )}
                        <button
                            disabled={loading}
                            className="Btn--Primary"
                            onClick={nextClicked}
                        >
                            {distTable ? t("payment.moveAction") : t("payment.pay")}
                        </button>
                    </div>
                </>
            )}
        </div>
    );
};

export default OrdersListWidget;
